var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyQuestHero = function SvgEmptyQuestHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 90,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-32.9%",
    y: "-16.7%",
    width: "165.9%",
    height: "160%",
    filterUnits: "objectBoundingBox",
    id: "EmptyQuestHero_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-3%",
    y: "-3%",
    width: "106%",
    height: "106%",
    filterUnits: "objectBoundingBox",
    id: "EmptyQuestHero_svg__b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "39.463%",
    x2: "73.145%",
    y2: "85.916%",
    id: "EmptyQuestHero_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAC8C8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B3B3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.342 40.878c-3.864-3.702-7.233-2.145-8.9-6.176-1.668-4.03 1.907-4.78 2.108-10.243.2-5.463-3.406-4.865-1.75-9.681 1.656-4.817 4.895-2.001 8.542-5.649C12.99 5.482 10.5 2.962 14.885.743c4.385-2.218 5.075 2.01 10.012 2.01s5.771-3.995 9.88-2.36c4.107 1.634 2.528 5.207 6.148 8.736 3.62 3.53 6.87 1.42 8.603 5.649 1.734 4.227-1.87 6.18-1.87 10.77 0 4.591 3.387 5.494 1.87 9.154-1.516 3.66-4.507 1.808-7.889 5.374-3.382 3.566-1.153 6.65-5.288 8.522-4.136 1.872-5.827-1.508-10.717-1.277-4.89.23-5.41 3.928-9.683 2.238s-2.744-4.98-6.609-8.681Z",
    id: "EmptyQuestHero_svg__c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmptyQuestHero_svg__a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.409 62.927 82 76.774H68.774V90L53.01 72.912l16.4-9.985Zm-40.418 9.985L13.226 90V76.774H0l12.591-13.847 16.4 9.985Z",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.169 69.694 5.848-3.897-2.608-2.87-16.4 9.985L68.774 90V76.774l-3.009-3.009a2.645 2.645 0 0 1 .404-4.07ZM12.59 62.927 0 76.774h13.226l3.802-3.802a2.645 2.645 0 0 1 3.272-.373l5.695 3.56 2.996-3.247-16.4-9.985Z",
    fill: "#B6B4B4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.906 1.8c.793 0 1.45.155 2.024.47l32.629 18.182c.199.11.36.267.472.454.109.182.169.393.169.611V59.04c0 .425-.23.815-.606 1.038L73.19 61.52 54.073 72.985l-11.148 6.683A3.733 3.733 0 0 1 41 80.2a3.735 3.735 0 0 1-1.927-.533l-11.146-6.682L8.811 61.52l-2.412-1.446A1.206 1.206 0 0 1 5.8 59.04V21.517c0-.218.06-.429.169-.61.111-.188.273-.346.48-.46L39.063 2.276a3.83 3.83 0 0 1 1.843-.475Zm.008 2.474a6.45 6.45 0 0 0-3.127.825l-27.2 15.477c-.695.399-1.25.961-1.631 1.62a4.368 4.368 0 0 0-.59 2.211v31.96a4.368 4.368 0 0 0 2.091 3.736l27.212 16.69a6.401 6.401 0 0 0 6.656.003l27.216-16.692a4.372 4.372 0 0 0 2.092-3.745V24.407a4.368 4.368 0 0 0-.589-2.211 4.418 4.418 0 0 0-1.625-1.617L44.213 5.1c-.936-.526-1.991-.82-3.299-.825Z",
    stroke: "#D5D5D5",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.833 24.403v31.964A2.573 2.573 0 0 1 70.6 58.57L43.39 75.258a4.607 4.607 0 0 1-4.78 0L11.4 58.569a2.573 2.573 0 0 1-1.233-2.202V24.403a2.594 2.594 0 0 1 1.31-2.263L38.672 6.666a4.65 4.65 0 0 1 2.25-.592h.155a4.65 4.65 0 0 1 2.25.592L70.524 22.14a2.594 2.594 0 0 1 1.31 2.263ZM51.792 42.519l7.708-10.63-12.333-1.519L41 19.74l-6.167 10.63L22.5 31.89l7.708 10.63-3.083 13.666L41 48.593l13.875 7.592-3.083-13.666Z",
    fill: "#CCC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.933 5.305a5.585 5.585 0 0 1 2.78.694l27.21 15.478c.53.302.959.732 1.253 1.237.293.504.453 1.083.45 1.689V56.37a3.323 3.323 0 0 1-1.604 2.85l-27.21 16.687a5.393 5.393 0 0 1-2.81.788c-.974 0-1.95-.262-2.809-.787L10.976 59.22a3.32 3.32 0 0 1-1.601-2.853v-31.97a3.3 3.3 0 0 1 .447-1.68c.293-.504.72-.934 1.247-1.236l27.2-15.477a5.472 5.472 0 0 1 2.664-.7Zm-.007.02a5.406 5.406 0 0 0-2.62.687l-27.2 15.476c-.527.303-.95.732-1.241 1.234a3.319 3.319 0 0 0-.448 1.685v31.96a3.32 3.32 0 0 0 1.59 2.841l27.211 16.69c.854.519 1.818.778 2.782.778s1.928-.26 2.78-.777l27.212-16.69a3.322 3.322 0 0 0 1.591-2.845V24.403a3.315 3.315 0 0 0-.448-1.68 3.369 3.369 0 0 0-1.239-1.233L43.7 6.014c-.794-.445-1.686-.686-2.773-.69Z",
    stroke: "#888787",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 15)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#EmptyQuestHero_svg__b)",
    xlinkHref: "#EmptyQuestHero_svg__c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#EmptyQuestHero_svg__d)",
    xlinkHref: "#EmptyQuestHero_svg__c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#888787",
    fillRule: "nonzero",
    cx: 25.076,
    cy: 24.952,
    rx: 16.905,
    ry: 16.822
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.346 39.034v4.962c0 .412.236.777.584.9l5.82 2.061a.738.738 0 0 0 .497 0l5.82-2.062c.348-.122.584-.487.584-.9v-4.96H34.346Z",
    fill: "#AFAEAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.741 41.348-6.395-2.25v4.898c0 .412.236.777.584.9l5.82 2.061c.081.029.165.043.249.043v-5.61a.74.74 0 0 1-.258-.042Z",
    fill: "#DBDBDA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFAEAC",
    d: "M30.188 37.62h1v7.54h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFAEAC",
    d: "m31.495 44.46-.891-1.683-.89 1.683-.714-.485 1.604-3.03 1.604 3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.235 46.396-.383.347 5.216-1.848c.347-.122.583-.487.583-.9v-4.904l-2.506.881c-.117 2.514-1.176 4.851-2.91 6.424Z",
    fill: "#9E9D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.766 36.743-10.523-3.7a.739.739 0 0 0-.509.005l-10.5 3.702c-.174.06-.295.242-.295.449-.001.207.118.39.292.452l10.51 3.697c.16.056.333.056.493 0l10.532-3.704c.174-.062.293-.244.293-.45 0-.207-.119-.39-.293-.45Z",
    fill: "#AFAEAC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDA",
    d: "m41.283 38.587 4.99-1.885.263.894-4.99 1.885z"
  })))));
};
export default SvgEmptyQuestHero;